import { addEvent } from '@/api/userEvent'

let timer = null
let count = 0
/**
 * @param {number} eventId 埋点ID
 */
export function analyseTracking(eventId) {
  if (!timer) {
    count++
    timer = setTimeout(() => {
      console.log(eventId)
      addEvent({ event_id: eventId })
      timer = null
      count = 0
    }, 500)
  } else {
    count++
    console.log(count)
  }
}
